var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKontaktMessenger48 = function SvgKontaktMessenger48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 45c-.1 0-.3 0-.4-.1-.3-.2-.4-.4-.4-.7v-5.9C6.5 34.5 4 29.2 4 23.6 4 12.8 13.2 4 24.5 4S45 12.8 45 23.6s-9.2 19.6-20.5 19.6c-2.6 0-5.2-.5-7.6-1.4l-4.8 3c-.1.2-.3.2-.4.2zM24.5 5.7c-10.4 0-18.8 8-18.8 17.9 0 5.2 2.4 10.1 6.5 13.6.2.2.3.4.3.7v4.7l3.8-2.4c.2-.1.5-.2.8-.1 2.3.9 4.8 1.4 7.4 1.4 10.4 0 18.8-8 18.8-17.9S34.9 5.7 24.5 5.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 29.6c-.3 0-.5-.1-.7-.3-.3-.3-.2-.8.1-1.1L21.3 18c.3-.3.8-.3 1.2 0l5.5 4.7 8.9-4.8c.4-.2.8-.1 1.1.2.3.3.2.8-.1 1.1L27.7 29.4c-.3.3-.8.3-1.2 0L21 24.7l-8.9 4.8c-.1.1-.3.1-.4.1zm9.4-6.8c.2 0 .4.1.6.2l5.4 4.6 5.5-5.5-4.2 2.3c-.3.2-.7.1-1-.1L22 19.7l-5.5 5.5 4.2-2.3c.1-.1.2-.1.4-.1z"
  })));
};
export default SvgKontaktMessenger48;